// support adrotate frontend advert randomisation for caching

// define containers to adjust which adverts display
const topOfPageBanner = jQuery( '.ad-toppbanner:not(.ad-topbanner-small-ads)' );
const sidebarAdvertsLarge = jQuery( '.ad-sidebar-large-screens aside:first-of-type .g-dyn' );
const startPageAdsWrapper = jQuery( '.adrotate.ads-start-page.page-refresh .g.g-4' );

betterRandomiseAdrotate( startPageAdsWrapper, true );
betterRandomiseAdrotate( topOfPageBanner, true );
randomiseAdrotate( sidebarAdvertsLarge );
detectImageOutBounds();

/**
 * Randomise the order of adverts so that a random selection is shown
 *
 * @param {Object} ads - adverts to be randomised
 * @return {void}
 */
function randomiseAdrotate( ads ) {
	for ( let i = 0; i < ads.length; i++ ) {
		const target = Math.floor( ( Math.random() * ads.length ) - 1 ) + 1;
		const target2 = Math.floor( ( Math.random() * ads.length ) - 1 ) + 1;
		ads.eq( target ).before( ads.eq( target2 ) );
	}
}

/**
 * Detects and removes image elements that are positioned out of bounds relative to the site footer.
 *
 * The comments for this function was generated by chatGPT
 */
function detectImageOutBounds() {
	jQuery( document ).ready( function() {
		jQuery( '.ajdg_grpwidgets .g-dyn' ).each( function() {
			// Get the bottom position of the current image element
			const bottom = jQuery( this ).position().top + jQuery( this ).outerHeight( true );
			// Get the top position of the site footer
			const footerTop = jQuery( '.site-footer' ).position().top;
			// Check if the bottom position of the image is close to or below the footer top position
			if ( ( footerTop - 100 ) <= bottom ) {
				jQuery( this ).remove(); // Remove the image element from the DOM
			}
		} );
	} );
}

/**
 * Shuffles the elements of an array using the Fisher-Yates shuffle algorithm.
 *
 * @param {Array} array - The array to be shuffled.
 * @return {Array} - The shuffled array.
 */
function shuffle( array ) {
	let currentIndex = array.length;
	let randomIndex;

	// While there remain elements to shuffle.
	while ( currentIndex !== 0 ) {
		// Pick a remaining element.
		randomIndex = Math.floor( Math.random() * currentIndex );
		currentIndex--;

		// And swap it with the current element.
		[ array[ currentIndex ], array[ randomIndex ] ] = [
			array[ randomIndex ], array[ currentIndex ],
		];
	}

	return array;
}

/**
 * Randomizes the order of ads within a given ad group container.
 *
 * @param {jQuery}  adGroup                - The container element for the ads.
 * @param {boolean} [addOnlyFirstAd=false] - Whether to add only the first ad from the randomized array. Defaults to false.
 */
function betterRandomiseAdrotate( adGroup, addOnlyFirstAd = false ) {
	let ads = adGroup.find( '.g-dyn' );
	// Convert the jQuery object of start page ads to a regular JavaScript array
	ads = ads.toArray();
	// Shuffle the order of start page ads
	ads = shuffle( ads );
	// Clear the contents of the startPageAdsWrapper container
	adGroup.empty();

	if ( addOnlyFirstAd ) {
		// Only add the first ad from the randomized array
		adGroup.append( ads[ 0 ] );
	} else {
		// Add all the ads from the randomized array
		adGroup.append( ads );
	}
}
